import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";

@Injectable({
    providedIn: 'root'
})
export class AlertService {

    constructor(private snackBar: MatSnackBar) { }

    public information(message: string,
                       duration = 3000): void {

        this.snackBar
            .open(message,
                'Ok',
                {duration: duration});
    }

    public success(message: string,
                   duration = 3000): void {
        this.snackBar
            .open(message,
                  'Ok',
                  {duration: duration});
    }

    public error(message: string,
                 error?: any,
                 duration = 5000): void {
        console.error(message, error);
        this.snackBar
            .open(error?.status === 0 ? "Communication problem, verify your connection" 
                                      : message,
                  'Ok',
                  {duration: duration,
                   verticalPosition: 'top',
                   panelClass: ["snackbar-warning"]});
    }
}
